import React, { createContext, useContext, useState, useCallback } from 'react';
import ChallengeCompletionModal from '../components/ChallengeCompletionModal';

const ChallengeNotificationContext = createContext();

export const useChallengeNotification = () => {
  const context = useContext(ChallengeNotificationContext);
  if (!context) {
    throw new Error('useChallengeNotification must be used within a ChallengeNotificationProvider');
  }
  return context;
};

export const ChallengeNotificationProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    open: false,
    challengeTitle: '',
    xpEarned: 0,
    challengeCategory: 'wellness'
  });

  const showChallengeCompletion = useCallback((challengeTitle, xpEarned, challengeCategory = 'wellness') => {
    setModalState({
      open: true,
      challengeTitle,
      xpEarned,
      challengeCategory
    });
  }, []);

  const hideChallengeCompletion = useCallback(() => {
    setModalState(prev => ({ ...prev, open: false }));
  }, []);

  const value = {
    showChallengeCompletion,
    hideChallengeCompletion
  };

  return (
    <ChallengeNotificationContext.Provider value={value}>
      {children}
      <ChallengeCompletionModal
        open={modalState.open}
        onClose={hideChallengeCompletion}
        challengeTitle={modalState.challengeTitle}
        xpEarned={modalState.xpEarned}
        challengeCategory={modalState.challengeCategory}
      />
    </ChallengeNotificationContext.Provider>
  );
};

export default ChallengeNotificationContext;
